import { useEffect } from "react";

// Inserts <meta name="robots" content="noindex, nofollow"> into <head> and
// returns a function that removes it again.
export function addNoindexMeta(doc = document) {
  const meta = doc.createElement("meta");
  meta.setAttribute("name", "robots");
  meta.setAttribute("content", "noindex, nofollow");
  doc.head.appendChild(meta);
  return () => {
    if (meta.parentNode) meta.parentNode.removeChild(meta);
  };
}

// Keeps the page out of search engines while the component is mounted.
export default function useNoindex() {
  useEffect(() => addNoindexMeta(), []);
}
